import {READING_TYPE, COUTER, RECEIVE_BOOK_ID, RECEIVE_CURRENT_PAGE, RECEIVE_DETAIL_INFO, RECEIVE_USER_INFO, RECEIVE_SEARCH_NAME, RECEIVE_FILTER_QUERY, RECEIVE_FILTER_LIST, RECEIVE_SEARCH_RESULT, RECEIVE_NAV_AREA, RECEIVE_INDEX_NAV} from './mutation-types'
import {reqItemDetail, reqUserInfo, reqSearchResult, reqCategorys, reqIndexCategorys, reqSearch} from '../api'

export default {
  // 异步获取导航地区分类
  async getNavArea ({commit}) {
    // 发送异步ajax请求
    const result = await reqCategorys()
    if (result) {
      const NavAreaCategorys = JSON.parse(result.resulter.facetPivot)
      commit(RECEIVE_NAV_AREA, {NavAreaCategorys})
      // 数据更新， 通知组件
    }
  },
  // 异步获取导航首页分类
  async getIndexNav ({commit}) {
    // 发送异步ajax请求
    const result = await reqIndexCategorys()
    if (result) {
      const indexNavList = JSON.parse(result.resulter.facetPivot)
      commit(RECEIVE_INDEX_NAV, {indexNavList})
      // 数据更新， 通知组件
    }
  },
  // 异步获取数据分类导航列表
  async getNavSearchResult ({commit}, {query, fq, pageNo, pageSize, core, highLight, facets, facetPivot, returnFeild, sort, searchType}) {
    // 发送异步ajax请求
    const result = await reqSearchResult({query, fq, pageNo, pageSize, core, highLight, facets, facetPivot, returnFeild, sort, searchType})
    if (result) {
      const data = result.data
      commit(RECEIVE_SEARCH_RESULT, {data})
      // 数据更新， 通知组件
    }
  },
  // 检索列表
  async getSearchList ({commit}, opt) {
    const searchresult = await reqSearch(opt)
    if (searchresult) {
      const queryList = JSON.parse(searchresult.resulter.results)
      commit(RECEIVE_SEARCH_RESULT, {queryList})
    }
  },
  // 存入筛选条件
  savaFilterList ({commit}, list) {
    // let list = Array.from(new Set(List))
    commit(RECEIVE_FILTER_LIST, {list})
  },
  savaFilterQuery ({commit}, list) {
    // let list = Array.from(new Set(List))
    commit(RECEIVE_FILTER_QUERY, {list})
  },
  saveQueryInfo ({commit}, queryInfo) {
    commit(RECEIVE_SEARCH_NAME, {queryInfo})
  },
  async getUserInfo ({commit}) {
    let userinfo = await reqUserInfo()
    commit(RECEIVE_USER_INFO, {userinfo})
  },

  // 检索条目详情
  async getItemDetail ({commit}, bookId) {
    let itemInfoObj = await reqItemDetail(bookId)
    if (itemInfoObj) {
      const itemInfoArr = JSON.parse(itemInfoObj.resulter.extraData)
      // const itemInfoArr = itemInfo[0]
      commit(RECEIVE_DETAIL_INFO, {itemInfoArr})
    }
  },
  // 存入当前页码
  saveCurrentPage ({commit}, curentPagePostion) {
    commit(RECEIVE_CURRENT_PAGE, {curentPagePostion})
  },
  // 存入当前bookId
  saveCurrentBookId ({commit}, bookId) {
    commit(RECEIVE_BOOK_ID, {bookId})
  },
  // 存入标识，代表第几次刷新页面
  saveCounter ({commit}, updataCouter) {
    commit(COUTER, {updataCouter})
  },
  // 存入资源类型标识
  savSourceType ({commit}, itemType) {
    commit(READING_TYPE, {itemType})
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js